export default __webpack_public_path__ + "static/media/warning-icon.8ee2a0ff.svg";